<template>
  <span :class="{'true': value}" class="boolean">{{value}}</span>
</template>

<script>
export default {
  props: ['value']
};
</script>
